import React, { useState } from "react";
import Header from "../components/Header";
import HeroSection from "../components/HeroSection"; 
import DashboardSection from "../components/DashboardSection";
import WCDProgramsSection from "../components/WCDProgramsSection";
import InteractiveMapSection from "../components/InteractiveMapSection";
import NewsSection from "../components/NewsSection";
import PartnershipsSection from "../components/PartnershipsSection";
import ChatbotSection from "../components/ChatbotSection";
import Footer from "../components/Footer";

const HomePage = () => {
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      <HeroSection />
      <DashboardSection />
      <WCDProgramsSection />
      <InteractiveMapSection />
      <NewsSection />
      <PartnershipsSection />
      <Footer />
      <ChatbotSection 
        isOpen={isChatbotOpen} 
        onToggle={() => setIsChatbotOpen(!isChatbotOpen)} 
      />
    </div>
  );
};

export default HomePage;